import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll vers le haut à chaque changement de route
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Scroll immédiat, pas d'animation
    });
  }, [pathname]);

  return null; // Ce composant ne rend rien
};

export default ScrollToTopOnRouteChange;